export const memoizePromise = <
  T extends (...args: any[]) => Promise<any>,
  P extends Parameters<T>,
>(
  fn: T,
) => {
  let promise: any;

  const memoizedFn = (...args: P) => {
    if (!promise) {
      promise = fn(...args).catch((e) => {
        promise = undefined;
        throw e;
      });
    }

    return promise;
  };

  return memoizedFn as (...args: P) => ReturnType<T>;
};
